import { Pipe, PipeTransform } from '@angular/core';
import { quoteStatusDropdown } from '../consts';

@Pipe({
  name: 'quoteStatusDescription',
  standalone: true
})
export class QuoteStatusDescriptionPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    const combined = [...quoteStatusDropdown()];
    const normalized = value.replace(/\s+/g, '').toLowerCase();
    const match = combined.find(
      item => item.id === value || item.id.replace(/\s+/g, '').toLowerCase() === normalized
    );
    return match?.description ?? value;
  }
}
